<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('shortkey profiles')"
      :columns="columns"
      :column_search="true"
      resource_url="/shortkey/profile/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <shortcut-profile-modal ref="shortcut_profile_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
} from "@/utils";
import ShortcutProfileModal from "./shortcut_profile_modal/Index.vue";

export default {
  name: "ShortcutProfileDatatable",
  components: { GenericTable, ShortcutProfileModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("name"),
          name: "name",
          searchable: true,
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.name || "";
          },
        },
        {
          title: v.$t("path"),
          name: "path",
          searchable: true,
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.path || "";
          },
        },
        {
          title: v.$t("shortkeys"),
          searchable: false,
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            let list = row.settings.shortkeys.reduce((acc, item) => {
              acc += `<li><span class="tag is-medium">${item.shortkey}</span> ${item.description}</li>`;
              return acc;
            }, "");
            return `<ul>${list}</ul>`;
          },
        },
        // {
        //   title: v.$t("data"),
        //   name: "data",
        //   searchable: true,
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return row.name || "";
        //   },
        // },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.shortcut_profile_modal.edit_modal(e.detail.uuid);
                },
              },
              // {
              //   args: { uuid: row.uuid },
              //   tooltip: v.$t("apply"),
              //   icon: "fa fa-check",
              //   icon_class: "is-small",
              //   click: function (e) {
              //     console.log("apply shortkey profile", row);
              //   },
              // },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete shortkey profile?"),
                    v,
                    () => {
                      del("/shortkey/profile", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.shortcut_profile_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
